import Vue from 'vue';
import Calendar from './vue-templates/Calendar'
import MobileCalendar from './vue-templates/MobileCalendar'

let app = new Vue( {
	el: '#vue-calendar',
	components: {
		'calendar': Calendar,
		'mobileCalendar' : MobileCalendar
	}
} );